const folderSubtle = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M6.21 1 7.5 2.69H16V15H0V1zm8.29 4.75h-13v7.75h13zM5.467 2.5H1.5v2.501h13V4.19H6.758z"/></svg>',
};

export { folderSubtle as default };
